import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file region Region上下文
 */
import { createContext } from '@tencent/glue-react-use';

var _createContext = createContext(),
    _createContext2 = _slicedToArray(_createContext, 2),
    RegionProvider = _createContext2[0],
    useRegionInstance = _createContext2[1];

export { RegionProvider, useRegionInstance };